export const MAXSIZEFILE =  10 * 1048576;

export const BOURSEDIRECT_PHONENUMBER = "01 56 88 40 40";
export const DIRECTSECURITIES_PHONENUMBER = "01 56 88 40 42";
export const MEILLEURTAUX_PHONENUMBER = "01 85 65 58 04";
